import { fetchGetMyAiOrderListAsync, OutputGetMyAiOrderList } from '@/typescript/Services/Api/OrderApi'
import Tools from '@/utils/Tools';
import { defineStore } from 'pinia'
import { string } from 'zod'
/**
 * 任务存储器
 */
export const useAiOrderStore = defineStore('aiOrderTask', {
    state: () => ({
        show: false,
        active: 0 as number,
        effectStatusArr: ['active', 'finish'] as string[],
        data: {
            page: 1,
            pageSize: 10,
            total: 0,
            list: [] as OutputGetMyAiOrderList[]
        }
    }),
    getters: {
    },
    actions: {
        /**
         * 加载数据
         */
        async LoadDataAsync() {
            const effectStatus = this.effectStatusArr[this.active] as any;
            const resp = await fetchGetMyAiOrderListAsync(this.data.page, this.data.pageSize, effectStatus);
            if (resp.CheckIsOk(false)) {
                this.data.total = resp.data!.total;

                this.data.list = resp.data!.list.map(x => {
                    return {
                        ...x,
                        OverTime: x.OverTime && x.OverTime > 0 ? x.OverTime : Tools.GetNowTime
                    }
                });
            }
        },
        /**
         * 获取运行时长
         */
        GetRunTime(v: OutputGetMyAiOrderList) {
            const overTime = v.OverTime ?? 0;
            const startTime = v.StartTime ?? 0;
            return Tools.FormatTimeWithMilliseconds(overTime - startTime, "HH:mm:ss.fff");
        }
    }
})
